import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  ProgressBar,
  Stack,
  Modal,
  OverlayTrigger,
  Tooltip,
  Popover,
} from "react-bootstrap";
import "./agentdashboard.css";
import Marketingsidebar from "../../../components/Marketing_bar";
import { StarFill, PatchCheckFill } from "react-bootstrap-icons";
import { Image } from "react-bootstrap";
import BackArrow from "../../../components/backArrow";
import ActiveModal from "../Active_Modal";
import { getAsset } from "../../../helpers/helper";
import InfoIcon from "@mui/icons-material/Info";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TotalSaleProfit from "./TotalSaleProfit";
import { useMarketingDashboard } from "../../../hooks/useMarketingDashboard";
import { useNavigate } from "react-router-dom";
import dummyAvatar from "../../../assets/images/dummy/user-avatar-img.jpg";
import { VerifyIcon } from "../../../assets";
import CustomPlanModal from "./CustomPlanModal";

const SkeletonDashboard = () => (
  <Row>
    <style>{`
      @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
      }
      .skeleton {
        animation: pulse 1.5s infinite ease-in-out;
        background: #e9ecef;
        border-radius: 4px;
        display: inline-block;
      }
    `}</style>
    <div className="screenHeight marketing-height-manage p-3">
      <Col
        lg="3"
        xl="3"
        sm="12"
        xs="12"
        className="bg-white shadow-sm marketing-sidebar-height sidebar-border rounded"
      >
        <div className="p-4">
          <div
            className="skeleton mb-3"
            style={{ width: "80%", height: "30px" }}
          />
          <div
            className="skeleton mb-2"
            style={{ width: "90%", height: "20px" }}
          />
          <div
            className="skeleton mb-2"
            style={{ width: "70%", height: "20px" }}
          />
          <div
            className="skeleton mb-2"
            style={{ width: "85%", height: "20px" }}
          />
        </div>
      </Col>

      <Col
        lg={8}
        md={12}
        sm={12}
        xs={12}
        className="p-5 pt-2 shadow rounded"
        style={{ backgroundColor: "#f8fbff" }}
      >
        <div className="mb-4">
          <div
            className="skeleton mb-2"
            style={{ width: "200px", height: "32px" }}
          />
          <div
            className="skeleton"
            style={{ width: "300px", height: "18px" }}
          />
        </div>

        <Card className="profile-card p-4 mb-4">
          <Row className="align-items-center">
            <Col xs={12} sm={2} md={2}>
              <div
                className="skeleton rounded-circle"
                style={{ width: "90px", height: "90px" }}
              />
            </Col>
            <Col xs={12} sm={10} md={10} className="mt-3 mt-sm-0">
              <div
                className="skeleton mb-2"
                style={{ width: "150px", height: "24px" }}
              />
              <div
                className="skeleton mb-2"
                style={{ width: "120px", height: "18px" }}
              />
              <div
                className="skeleton"
                style={{ width: "250px", height: "18px" }}
              />
            </Col>
          </Row>
        </Card>

        <Row className="mb-4 g-3">
          {[1, 2, 3].map((i) => (
            <Col key={i} xs={12} sm={6} lg={4}>
              <Card className="text-center p-4">
                <div
                  className="skeleton mx-auto mb-2"
                  style={{ width: "120px", height: "20px" }}
                />
                <div
                  className="skeleton mx-auto"
                  style={{ width: "50px", height: "36px" }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
    </div>
  </Row>
);

const ErrorDashboard = ({ error }) => (
  <Container className="d-flex flex-column align-items-center justify-content-center py-5">
    <Card
      className="shadow border-0 p-5 text-center"
      style={{ maxWidth: "500px", borderRadius: "16px" }}
    >
      <div className="text-danger mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          fill="currentColor"
          className="bi bi-exclamation-triangle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </svg>
      </div>
      <h4 className="fw-bold text-dark mb-2">Failed to Load Dashboard</h4>
      <p className="text-muted mb-4">
        {error?.data?.message ||
          error?.message ||
          "An unexpected error occurred. Please check your connection and try again."}
      </p>
      <Button
        variant="primary"
        className="px-4 py-2"
        onClick={() => window.location.reload()}
        style={{
          backgroundColor: "#0052cc",
          border: "none",
          borderRadius: "8px",
        }}
      >
        Reload Page
      </Button>
    </Card>
  </Container>
);

export default function AgentDashboard() {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const imgRef = React.useRef();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);
  const [showPlanModal, setShowPlanModal] = React.useState(false);

  React.useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setImageLoaded(true);
    }
  }, []);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const resolveShopAvatar = (shop) => {
    const raw =
      (Array.isArray(shop?.image) && shop.image.find(Boolean)) ||
      (Array.isArray(shop?.images) && shop.images.find(Boolean)) ||
      shop?.image ||
      shop?.images ||
      null;
    if (!raw || raw === "N/A" || raw === "null" || raw === "undefined") {
      return dummyAvatar;
    }
    const src = Array.isArray(raw) ? raw.find(Boolean) : raw;
    if (!src || typeof src !== "string" || !src.trim()) return dummyAvatar;
    return getAsset(src) || dummyAvatar;
  };

  const formatReviewDateTime = (dateInput) => {
    if (!dateInput) return "";
    const d = new Date(dateInput);
    if (Number.isNaN(d.getTime())) return "";
    const datePart = d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    const timePart = d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart} · ${timePart}`;
  };

  const {
    name,
    isOpen,
    setIsOpen,
    activemodal,
    setActivemodal,
    show,
    setShow,
    visibleReviews,
    showMoreReviews,
    onHide,
    marketerdata,
    checkboxData,
    projectStatus,
    ratingData,
    isLevelCompleted,
    completedLevel,
    completedTierName,
    commissionRate,
    isLoading,
    isError,
    error,
  } = useMarketingDashboard();

  const verifyPopover = (
    <Popover
      id="verify-agent-popover"
      className="shadow border-0"
      style={{ zIndex: 9999 }}
    >
      <Popover.Body
        className="p-3 text-start"
        style={{ fontSize: "14px", color: "#333", minWidth: "220px" }}
      >
        <div className="fw-bold text-success mb-1">Verified Agent</div>
        <div className="text-muted" style={{ fontSize: "12px" }}>
          {name?.fullname || "Agent"} is verified & active.
        </div>
      </Popover.Body>
    </Popover>
  );

  if (isLoading) {
    return <SkeletonDashboard />;
  }

  if (isError) {
    return <ErrorDashboard error={error} />;
  }

  return (
    <Row>
      <ActiveModal show={activemodal} onHide={() => setActivemodal(false)} />
      <div className="screenHeight marketing-height-manage p-3">
        <Col
          lg="3"
          xl="3"
          sm="12"
          xs="12"
          className="bg-white shadow-sm marketing-sidebar-height sidebar-border rounded"
        >
          <Marketingsidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        </Col>

        {/* MAIN CONTENT */}
        <Col
          lg={8}
          md={12}
          sm={12}
          xs={12}
          className="p-5 pt-2 shadow rounded"
          style={{ backgroundColor: "#f8fbff" }}
        >
          <BackArrow />
          <Row>
            <Col xs={12}>
              <h2 className="dash-title">Agent Dashboard</h2>
              <p className="dash-sub">
                Ourview of agent performance and activities
              </p>
            </Col>
          </Row>

          {/* PROFILE CARD */}
          <Row>
            <Col xs={12}>
              <Card className="profile-card p-4">
                <Row className="align-items-center">
                  <Col xs={12} sm={2} md={2} className="text-start">
                    <div
                      className="profile-img position-relative"
                      style={{
                        width: "90px",
                        height: "90px",
                        overflow: "hidden",
                      }}
                    >
                      {!imageLoaded && (
                        <div
                          className="skeleton rounded-circle position-absolute top-0 start-0 w-100 h-100"
                          style={{ zIndex: 1 }}
                        />
                      )}
                      <img
                        ref={imgRef}
                        src={
                          name?.imageUrl &&
                          name.imageUrl.length > 0 &&
                          name.imageUrl[0] !== ""
                            ? getAsset(name.imageUrl)
                            : dummyAvatar
                        }
                        alt="Profile Avatar"
                        className="profile-img-22 rounded-circle w-100 h-100"
                        crossOrigin="anonymous"
                        loading="lazy"
                        onLoad={() => setImageLoaded(true)}
                        onError={(e) => {
                          if (e.target.src !== dummyAvatar) {
                            e.target.src = dummyAvatar;
                          }
                          setImageLoaded(true);
                        }}
                        style={{
                          opacity: imageLoaded ? 1 : 0,
                          transition: "opacity 0.2s ease-in-out",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </Col>

                  <Col xs={10} sm={10} md={10} className="text-end">
                    <InfoIcon
                      style={{ color: "red", cursor: "pointer" }}
                      className="mb-3"
                      onClick={() => setShow(true)}
                    />{" "}
                    &nbsp;
                    <button
                      className={`btn ${checkboxData?.submitDoc && checkboxData?.connection ? "btn-success" : "btn-warning"} disabled mb-3 text-capitalize`}
                      style={{
                        opacity: 1,
                        color:
                          checkboxData?.submitDoc && checkboxData?.connection
                            ? "#fff"
                            : "#000",
                      }}
                    >
                      {checkboxData?.submitDoc && checkboxData?.connection
                        ? "approved"
                        : "pending"}
                    </button>
                  </Col>
                  <Col xs={12} sm={12} md={12}>
                    <h4 className="profile-name mt-3 d-flex align-items-center gap-2 flex-wrap">
                      <span>{name?.fullname}</span>
                      <div
                        ref={dropdownRef}
                        className="position-relative d-inline-block"
                      >
                        <button
                          onClick={() => setMenuOpen(!menuOpen)}
                          className="btn btn-light btn-sm rounded-circle p-1 d-flex align-items-center justify-content-center"
                          style={{
                            width: "26px",
                            height: "26px",
                            border: "1px solid #cbd5e1",
                            backgroundColor: "#f8fafc",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            cursor: "pointer",
                          }}
                        >
                          <KeyboardArrowDownIcon
                            style={{
                              transition: "transform 0.2s ease-in-out",
                              transform: menuOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              fontSize: "18px",
                              color: "#475569",
                            }}
                          />
                        </button>

                        {menuOpen && (
                          <div
                            className="position-absolute dropdown-menu-animated p-1 shadow rounded border bg-white"
                            style={{
                              top: "100%",
                              left: "0",
                              zIndex: 9999,
                              minWidth: "160px",
                              marginTop: "6px",
                              height: "40px",
                            }}
                          >
                            <button
                              className="btn btn-primary btn-sm mt-0 w-100 text-start d-flex align-items-center justify-content-center"
                              style={{
                                backgroundColor: "#0052cc",
                                border: "none",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "6px 12px",
                                borderRadius: "6px",
                              }}
                              onClick={() => {
                                setMenuOpen(false);
                                setShowPlanModal(true);
                              }}
                            >
                              Add Account
                            </button>
                          </div>
                        )}
                      </div>

                      {marketerdata?.Status === "approved" &&
                        checkboxData?.submitDoc &&
                        checkboxData?.connection && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="right"
                            overlay={verifyPopover}
                          >
                            <span
                              style={{
                                cursor: "pointer",
                                display: "inline-flex",
                                alignSelf: "center",
                              }}
                            >
                              <VerifyIcon
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                          </OverlayTrigger>
                        )}

                      {/* Current Level Badge (shown when level 1+ completed) */}
                      {isLevelCompleted && (
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="completed-level-badge-tooltip">
                              <div style={{ textAlign: "left", padding: "4px 6px" }}>
                                <div style={{ fontWeight: 700, fontSize: "12px", color: "#fff" }}>
                                  Level {completedLevel} Completed!
                                </div>
                                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.9)" }}>
                                  Current Tier: <strong>{completedTierName}</strong>
                                </div>
                                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.9)" }}>
                                  Active Commission: <strong>{commissionRate}%</strong>
                                </div>
                                <div style={{ fontSize: "10px", marginTop: "4px", color: "#a7f3d0", fontWeight: 600 }}>
                                  Click to view Level Roadmap &amp; Rewards →
                                </div>
                              </div>
                            </Tooltip>
                          }
                        >
                          <span
                            role="button"
                            tabIndex={0}
                            onClick={() => navigate("/marketing-rewards")}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                navigate("/marketing-rewards");
                              }
                            }}
                            className="badge rounded-pill d-inline-flex align-items-center gap-1.5 px-2.5 py-1 text-white shadow-sm"
                            style={{
                              background: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
                              fontSize: "12px",
                              fontWeight: "600",
                              letterSpacing: "0.2px",
                              cursor: "pointer",
                              border: "1px solid rgba(255, 255, 255, 0.35)",
                              boxShadow: "0 2px 6px rgba(16, 185, 129, 0.35)",
                              userSelect: "none",
                              verticalAlign: "middle",
                              transition: "all 0.2s ease-in-out",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-1px)";
                              e.currentTarget.style.boxShadow =
                                "0 4px 10px rgba(16, 185, 129, 0.45)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow =
                                "0 2px 6px rgba(16, 185, 129, 0.35)";
                            }}
                          >
                            <PatchCheckFill
                              style={{
                                fontSize: "13px",
                                color: "#fbbf24",
                                filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.2))",
                              }}
                            />
                            <span>Level {completedLevel}</span>
                            <span
                              style={{
                                opacity: 0.92,
                                fontWeight: 500,
                                fontSize: "11px",
                              }}
                            >
                              • {completedTierName}
                            </span>
                          </span>
                        </OverlayTrigger>
                      )}
                    </h4>
                    <p className="profile-role mb-0">
                      Agent ID#{" "}
                      {marketerdata?._id
                        ? `MA-${marketerdata._id.slice(-8).toUpperCase()}`
                        : marketerdata?.marketerId}
                    </p>
                    <p className="profile-role">
                      Marketing Area:{" "}
                      {marketerdata?.MIndustryName?.map(
                        (data) => `${data?.name} `,
                      )}
                    </p>
                    {marketerdata?.Status === "approved" && (
                      <p className="profile-role mb-0">
                        Approved Zone:{" "}
                        <strong>
                          {checkboxData?.sameZoneName ||
                            marketerdata?.MCity ||
                            "N/A"}
                        </strong>
                      </p>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    className="text-left mt-3 mt-sm-0"
                  >
                    {/* Show Activate button if no docs submitted yet OR if rejected AND not already approved */}
                    {(checkboxData?.submitDoc === false ||
                      marketerdata?.Status === "rejected") &&
                      marketerdata?.Status !== "approved" && (
                        <>
                          <Button
                            className="profile-btn"
                            onClick={() => setActivemodal(true)}
                          >
                            Activate your Account
                          </Button>
                          <br />
                        </>
                      )}
                    <Button
                      className="profile-btn mt-2"
                      onClick={() => {
                        localStorage.setItem(
                          "previousRoute",
                          "marketing-profile",
                        );
                        navigate("/marketing-profile");
                      }}
                    >
                      Manage your profile
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          {/* STATS BOXES */}
          <Row className="mt-4 g-3">
            <Col xs={12} sm={6} lg={4}>
              <Card className=" text-center">
                <h6
                  className="text-white p-3 "
                  style={{
                    backgroundColor: "#0052cc",
                    borderTopLeftRadius: "0.375rem",
                    borderTopRightRadius: "0.375rem",
                  }}
                >
                  Completed projects
                </h6>
                <h2 className="bg-white p-4">
                  {projectStatus?.completedProjects}
                </h2>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <Card className="text-center ">
                <h6
                  className="text-white p-3 "
                  style={{
                    backgroundColor: "#0052cc",
                    borderTopLeftRadius: "0.375rem",
                    borderTopRightRadius: "0.375rem",
                  }}
                >
                  Ongoing projects
                </h6>
                <h2 className="bg-white p-4">
                  {projectStatus?.ongoingProjects}
                </h2>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <Card className=" text-center ">
                <h6
                  className="text-white p-3 "
                  style={{
                    backgroundColor: "#0052cc",
                    borderTopLeftRadius: "0.375rem",
                    borderTopRightRadius: "0.375rem",
                  }}
                >
                  Total sales
                </h6>
                <h2 className="bg-white p-4">{projectStatus?.totalClients}</h2>
              </Card>
            </Col>
          </Row>

          <TotalSaleProfit data={marketerdata} />

          {/* REVIEWS SECTION */}
          <section className="agent-rating py-4">
            <h4 className="mb-4">Agent Rating & Feedback</h4>

            <Row className="align-items-center g-4">
              <Col xs={12} md={4} className="text-center text-md-start">
                <div className="display-3 fw-bold text-dark">
                  {ratingData?.topReviewSection?.averageRating ?? 0}
                </div>

                <Stack direction="horizontal" gap={1}>
                  {[...Array(5)].map((_, i) => (
                    <StarFill
                      key={i}
                      size={20}
                      className={
                        i <
                        Math.round(
                          ratingData?.topReviewSection?.averageRating ?? 0,
                        )
                          ? "text-warning"
                          : "text-muted"
                      }
                    />
                  ))}
                </Stack>

                <small className="text-muted">
                  {ratingData?.topReviewSection?.totalReviews ?? 0} reviews
                </small>
              </Col>

              <Col xs={12} md={8}>
                {[5, 4, 3, 2, 1].map((star) => (
                  <Stack
                    key={star}
                    direction="horizontal"
                    gap={2}
                    className="align-items-center mb-1"
                  >
                    <span style={{ width: 20 }}>{star}</span>

                    <ProgressBar
                      now={
                        ratingData?.topReviewSection?.totalReviews
                          ? Math.round(
                              ((ratingData?.topReviewSection?.ratingRatio?.[
                                star === 5
                                  ? "fiveStar"
                                  : star === 4
                                    ? "fourStar"
                                    : star === 3
                                      ? "threeStar"
                                      : star === 2
                                        ? "twoStar"
                                        : "oneStar"
                              ] ?? 0) /
                                ratingData.topReviewSection.totalReviews) *
                                100,
                            )
                          : 0
                      }
                      className="flex-fill"
                      style={{ height: 8 }}
                      variant={star === 5 ? "warning" : undefined}
                    />

                    <span style={{ width: 40, textAlign: "right" }}>
                      {ratingData?.topReviewSection?.totalReviews
                        ? Math.round(
                            ((ratingData?.topReviewSection?.ratingRatio?.[
                              star === 5
                                ? "fiveStar"
                                : star === 4
                                  ? "fourStar"
                                  : star === 3
                                    ? "threeStar"
                                    : star === 2
                                      ? "twoStar"
                                      : "oneStar"
                            ] ?? 0) /
                              ratingData.topReviewSection.totalReviews) *
                              100,
                          )
                        : 0}
                      %
                    </span>
                  </Stack>
                ))}
              </Col>
            </Row>
          </section>

          <Row className="mt-4">
            <Col xs={12}>
              {ratingData?.ratings?.slice(0, visibleReviews)?.map((rev, i) => (
                <Card key={rev?._id || i} className="review-card p-3 mb-3">
                  <div className="d-flex">
                    <Image
                      src={resolveShopAvatar(rev?.shopid)}
                      roundedCircle
                      width={48}
                      height={48}
                      alt={rev?.shopid?.shopname || "shop avatar"}
                      crossOrigin="anonymous"
                      style={{ objectFit: "cover", background: "#e9ecef" }}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.removeAttribute("crossorigin");
                        e.currentTarget.src = dummyAvatar;
                      }}
                    />

                    <div className="ms-2">
                      <h6 className="mb-0 fw-semibold">
                        {rev?.shopid?.shopname ?? "Anonymous"}
                      </h6>
                      <p className="mb-0 text-muted font_11">
                        {formatReviewDateTime(rev.createdAt)}
                      </p>
                    </div>
                  </div>

                  <div className="stars text-warning">
                    {"★".repeat(rev.rating)}
                  </div>

                  <p className="review-text">{rev.comment}</p>
                </Card>
              ))}

              {visibleReviews < (ratingData?.ratings?.length ?? 0) && (
                <Button
                  className="view-more-btn text-white"
                  onClick={showMoreReviews}
                >
                  View More
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </div>

      {/* ------------Modal----------- */}

      <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
        {/* Header */}
        <div className="aam-header">
          <h5>Agent Account Activation Requirements</h5>
          <span className="aam-close" onClick={onHide}>
            ✖
          </span>
        </div>

        {/* Body */}
        <div className="aam-body">
          <p className="aam-subtitle">
            Complete The Following Requirements To Activate Your Agent Account.
          </p>

          {/* Submit Documents */}
          <div className="aam-item">
            <div
              className={`aam-checkbox ${checkboxData?.submitDoc && marketerdata?.Status === "approved" ? "checked" : ""}`}
            >
              {checkboxData?.submitDoc &&
                marketerdata?.Status === "approved" && (
                  <CheckIcon fontSize="small" />
                )}
            </div>

            <div>
              <h6>Submit Required Documents</h6>
              <p>Upload and submit all required documents for verification.</p>
            </div>
          </div>

          {/* Minimum Connections */}
          <div className="aam-item">
            <div
              className={`aam-checkbox ${
                checkboxData?.connection ? "checked" : ""
              }`}
            >
              {checkboxData?.connection && <CheckIcon fontSize="small" />}
            </div>

            <div>
              <h6>Minimum Connections Required</h6>
              <p>
                You must have at least 2 connections in your own
                {checkboxData?.sameZoneName ? (
                  <> <strong>{checkboxData.sameZoneName}</strong></>
                ) : (
                  " zone"
                )}{" "}
                on your agent profile.
                {checkboxData?.sameZoneConnectionsCount !== undefined && (
                  <> (Current: {checkboxData.sameZoneConnectionsCount}/2)</>
                )}
              </p>
            </div>
          </div>
        </div>
      </Modal>

      <CustomPlanModal
        show={showPlanModal}
        onHide={() => setShowPlanModal(false)}
      />
    </Row>
  );
}
